class ReclassificacaoFiscalModal {
    static get $inject() {
        return ['$scope', 'gql']
    }

    static get produtosFields() {
        return `
            id
            descricao
            codigo
            ncm
            exTipi
            cest                        
            codigoBarras
            reclassificacao {
                id
                status
                conclusoes
                problemas
                updatedAt
            }
        `
    }

    constructor($scope, gql) {
        this.apply = fn => $scope.$apply(fn)
        this.gql = gql
    }

    $onInit() {
        this.promise = this
            .loadProduto()
            .then(({ produto, reclassificacao, filial }) => {
                this.produto = produto
                this.reclassificacao = reclassificacao
                this.filial = filial
                this.subscribeProduto(produto)

                return this.loadResultadoReclassificacao()
            })
            .then(resultado => {
                const hasResultado = resultado
                    && ['CONCLUIDA', 'PROBLEMAS_ENCONTRADOS'].includes(this.reclassificacao.status)
                    && !this.reclassificacao.problemaWithCodigoBarras

                this.reclassificacao = {
                    ...this.reclassificacao,
                    hasResultado,
                    resultado
                }
            })
            .catch(([{ message }]) => {
                this.error = message
            })
            .finally(() => this.apply())
    }

    $onDestroy() {
        if (this.unsubscriber) this.unsubscriber()
    }

    loadProduto() {
        const query = gql`
            query GetProduto($filialId: Int!, $produtoId: String!) {
                filial(id: $filialId) {
                    id
                    produto(id: $produtoId) {
                        ${ReclassificacaoFiscalModal.produtosFields}
                    }
                    produtosContratados: ferramentasContratadas
                }
            }
        `

        const { produtoId, filialId } = this.resolve

        return this.gql
            .query(query, { produtoId, filialId: parseInt(filialId) })
            .then(({ filial }) => filial)
            .then(filial => ({ ...this.parseProduto(filial.produto), filial }))
    }

    loadResultadoReclassificacao() {
        const query = gql`
            query GetReclassificacao($filialId: Int!, $produtoId: String!) {
                filial(id: $filialId) {
                    id
                    produto(id: $produtoId) {
                        id
                        reclassificacao {
                            id
                            conclusoes
                            resultado {
                                descricao
                                ncm
                                cest
                                exTipi
                                solved {
                                    cest
                                    ex_tipi
                                    ncm
                                }
                            }
                        }
                    }
                }
            }
        `

        const { produtoId, filialId } = this.resolve

        return this.gql
            .query(query, { produtoId, filialId: parseInt(filialId) })
            .then(({ filial: { produto } }) => produto)
            .then(({ reclassificacao: { resultado } }) => resultado)
    }

    subscribeProduto({ id: produtoId }) {
        const subscription = `
            subscription($produtoId: String!) {
                produto: produtoUpdated(produtoId: $produtoId) {                    
                    ${ReclassificacaoFiscalModal.produtosFields}
                    reclassificacao {
                        id
                        status
                        problemas
                        conclusoes
                        updatedAt
                        resultado {
                            descricao
                            ncm
                            cest
                            exTipi
                            solved {
                                cest
                                ex_tipi
                                ncm
                            }
                        }
                    }
                }
            }
        `

        this.unsubscriber = this.gql
            .subscribe(subscription, { produtoId }, ({ data: { produto: result }, errors }) => {
                this.apply(() => {
                    const { produto, reclassificacao } = this.parseProduto(result)

                    this.produto = produto
                    this.reclassificacao = reclassificacao

                    if (errors) {
                        this.error = errors[0].message
                    }
                })
            })
    }

    parseProduto({ reclassificacao, ...produto }) {
        const problemaWithCodigoBarras = reclassificacao.problemas
            .find(p => ['INVALID_CODIGO_BARRAS', 'MISSING_CODIGO_BARRAS'].includes(p))

        return {
            produto,
            reclassificacao: {
                ...reclassificacao,
                problemaWithCodigoBarras
            }
        }
    }

    hasConclusao(conclusao) {
        return this.reclassificacao && this.reclassificacao.conclusoes.includes(conclusao)
    }
}

angular
    .module('eficienciaFiscalModule')
    .component('reclassificacaoFiscalModal', {
        controller: ReclassificacaoFiscalModal,
        bindings: {
            close: '&',
            resolve: '<'
        },
        template: `
            <modal modal-title="Reclassificação fiscal" close="$ctrl.close">
                <modal-body>
                    <loading promise="$ctrl.promise">                        
                        <highlighted>
                            <main>Reclassificação fiscal de produtos</main>
                            <secondary>
                                Confira abaixo o resultado da reclassificação do produto de código <b>{{$ctrl.produto.codigo}}</b>
                            </secondary>
                        </highlighted>
                        
                        <div class="content">
                            <div class="reclassificacao-header">
                                <div>
                                    <b>Código</b>
                                    <br>
                                    <span>{{$ctrl.produto.codigo}}</span>
                                </div>
                                <div>
                                    <b>Código de barras</b>
                                    <br>
                                    <span>{{$ctrl.produto.codigoBarras || '--'}}</span>
                                </div>
                                <div>
                                    <b>Reclassificação realizada em</b>
                                    <br>
                                    <span>{{$ctrl.reclassificacao.updatedAt | date: 'dd/MM/yyyy HH:mm'}}</span>
                                </div>
                            </div>

                            <div class="panel-divergencias">
                                <div>
                                    <h3>Dados cadastrados</h3>
                                    <dl>
                                        <dt>Descrição</dt>
                                        <dd>{{ $ctrl.produto.descricao }}</dd>
                                       
                                        <dt>
                                            NCM
                                            <i
                                                class="fa fa-exclamation-triangle text-danger" 
                                                tooltip="A NCM do produto é divergente da reclassificação."
                                                ng-if="$ctrl.hasConclusao('NCM_DIVERGENTE')">
                                            </i>

                                            <i 
                                                class="fa fa-exclamation-triangle text-danger" 
                                                tooltip="A NCM do produto é inválida."
                                                ng-if="$ctrl.hasConclusao('NCM_INVALIDA')">
                                            </i>
                                        </dt>
                                        <dd ng-class="{'text-danger': $ctrl.hasConclusao('NCM_DIVERGENTE') || $ctrl.hasConclusao('NCM_INVALIDA')}">
                                            {{($ctrl.produto.ncm | efMask:"0000.00.00") || '--'}}
                                        </dd>

                                        <dt>
                                            EX TIPI                                               
                                            <i 
                                                class="fa fa-exclamation-triangle text-danger" 
                                                tooltip="A EX TIPI do produto é divergente da reclassificação."
                                                ng-if="$ctrl.hasConclusao('EX_TIPI_DIVERGENTE')">
                                            </i>

                                            <i 
                                                class="fa fa-exclamation-triangle text-danger" 
                                                tooltip="A EX TIPI do produto é inválida."
                                                ng-if="$ctrl.hasConclusao('EX_TIPI_INVALIDA')">
                                            </i>
                                        </dt>
                                        <dd ng-class="{'text-danger': $ctrl.hasConclusao('EX_TIPI_DIVERGENTE') || $ctrl.hasConclusao('EX_TIPI_INVALIDA')}">
                                            <span ng-show="$ctrl.produto.exTipi">{{$ctrl.produto.exTipi}}</span>
                                            <span ng-hide="$ctrl.produto.exTipi" class="empty">VAZIO</span>
                                        </dd>

                                        <dt>
                                            CEST
                                            <i 
                                                class="fa fa-exclamation-triangle text-danger" 
                                                tooltip="O CEST do produto é divergente da reclassificação."
                                                ng-if="$ctrl.hasConclusao('CEST_DIVERGENTE')">
                                            </i>
                                            
                                            <i 
                                                class="fa fa-exclamation-triangle text-danger" 
                                                tooltip="O CEST do produto é inválido."
                                                ng-if="$ctrl.hasConclusao('CEST_INVALIDO')">
                                            </i>
                                        </dt>
                                        <dd ng-class="{'text-danger': $ctrl.hasConclusao('CEST_DIVERGENTE') || $ctrl.hasConclusao('CEST_INVALIDO')}">
                                            <span ng-show="$ctrl.produto.cest">{{($ctrl.produto.cest | efMask:"00.000.00")}}</span>
                                            <span ng-hide="$ctrl.produto.cest" class="empty">VAZIO</span>
                                        </dd>
                                    </dl>
                                </div>
                                <div class="divider"></div>
                                <div class="reclassificacao-resultado">
                                    <h3>Resultado da reclassificação</h3>
                                    <dl ng-if="$ctrl.reclassificacao.hasResultado && !$ctrl.error">
                                        <dt>Descrição</dt>
                                        <dd>{{$ctrl.reclassificacao.resultado.descricao}}</dd>

                                        <dt>NCM</dt>
                                        <dd ng-if="$ctrl.reclassificacao.resultado.ncm">
                                            {{($ctrl.reclassificacao.resultado.ncm | efMask:"0000.00.00")}}
                                        </dd>
                                        <span ng-if="!$ctrl.reclassificacao.resultado.ncm" class="empty">
                                            <span
                                                ng-show="$ctrl.reclassificacao.resultado.solved.ncm"
                                                tooltip="Este item não possui NCM.">
                                                VAZIO
                                            </span>
                                            <span
                                                ng-hide="$ctrl.reclassificacao.resultado.solved.ncm"
                                                tooltip="Não encontramos uma NCM para este item.">
                                                NÃO ENCONTRADO
                                            </span>
                                        </span>
                                        
                                        <dt>EX TIPI</dt>
                                        <dd ng-if="$ctrl.reclassificacao.resultado.exTipi">
                                            {{$ctrl.reclassificacao.resultado.exTipi}}
                                        </dd>
                                        <span ng-if="!$ctrl.reclassificacao.resultado.exTipi" class="empty">
                                            <span
                                                ng-show="$ctrl.reclassificacao.resultado.solved.ex_tipi"
                                                tooltip="Este item não possui EX TIPI.">
                                                VAZIO
                                            </span>
                                            <span
                                                ng-hide="$ctrl.reclassificacao.resultado.solved.ex_tipi"
                                                tooltip="Não encontramos uma EX TIPI para este item.">
                                                NÃO ENCONTRADO
                                            </span>
                                        </span>

                                        <dt>CEST</dt>
                                        <dd ng-if="$ctrl.reclassificacao.resultado.cest">
                                            {{($ctrl.reclassificacao.resultado.cest | efMask:"00.000.00")}}
                                        </dd>
                                        <span ng-if="!$ctrl.reclassificacao.resultado.cest" class="empty">
                                            <span
                                                ng-show="$ctrl.reclassificacao.resultado.solved.cest"
                                                tooltip="Este item não possui CEST.">
                                                VAZIO
                                            </span>
                                            <span
                                                ng-hide="$ctrl.reclassificacao.resultado.solved.cest"
                                                tooltip="Não encontramos um CEST para este item.">
                                                NÃO ENCONTRADO
                                            </span>
                                        </span>
                                    </dl>

                                    <div 
                                        class="fade-animation reclassificao-overlay avaliacao"
                                        ng-if="$ctrl.error == 'free_limit_reached'">
                                        <h5> Obrigado por testar a nossa nova ferramenta de reclassificação fiscal de itens! Por favor,
                                            <a href="javascript:Intercom('show')"> clique aqui</a> e deixe o seu comentário, ele é muito importante para nós!
                                        </h5>
                                    </div> 

                                    <dl class="resultado-blur" ng-if="$ctrl.error == 'free_limit_reached'">
                                        <dt>Descrição</dt>
                                        <dd>{{$ctrl.produto.descricao}}</dd>
                                        <dt>NCM</dt>
                                        <dd>0000.00.00</dd>
                                        <dt>EX TIPI</dt>
                                        <dd>000</dd>
                                        <dt>CEST</dt>
                                        <dd>00.000.00</dd>
                                    </dl>
                                    
                                    <div class="resultado text-danger" ng-if="$ctrl.reclassificacao.problemaWithCodigoBarras">
                                        Não foi possível reclassificar este produto.
                                        <div ng-switch="$ctrl.reclassificacao.problemaWithCodigoBarras">
                                            <span ng-switch-when="INVALID_CODIGO_BARRAS">
                                                O código de barras informado possivelmente é inválido.
                                            </span>
                                            <span ng-switch-when="MISSING_CODIGO_BARRAS">
                                                O produto não possui código de barras cadastrado.
                                            </span>
                                        </div>
                                    </div>

                                    <div class="resultado text-center" ng-if="$ctrl.reclassificacao.status == 'NCM_DISPENSA_CODIGO_BARRAS'">
                                        É possível que este produto não possua código de barras, exceto 
                                        se tratar de produto industrializado em embalagem do fornecedor.
                                    </div>

                                    <div class="resultado text-center" ng-if="$ctrl.hasConclusao('NAO_RECLASSIFICADO')">
                                        Não encontramos uma classificação para este produto.
                                    </div>

                                    <div class="resultado text-center" ng-if="$ctrl.hasConclusao('PARAMETROS_INCONSISTENTES') && !$ctrl.reclassificacao.resultado">
                                        Os dados deste item foram mantidos, porém há inconsistências em seus parâmetros fiscais.
                                    </div>
                                    
                                    <div class="reclassificacao-pendente text-info" ng-if="$ctrl.reclassificacao.status === 'PENDENTE'">
                                        <div>
                                            Reclassificação do produto em andamento<span>.</span><span>.</span><span>.</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="avaliacao"
                            ng-if="!$ctrl.error && $ctrl.reclassificacao.resultado && !$ctrl.filial.produtosContratados.includes('reclassificacao-fiscal')">
                            <h5 class="text-muted"> Você está usando a sua franquia gratuita de <b>5</b> reclassificações fiscais diárias.</h5>
                        </div>
                    </loading>
                </modal-body>
                <modal-footer>
                    <button class="btn btn-default" type="button" ng-click="$ctrl.close()">Fechar</button>
                </modal-footer>
            </modal>
        `
    })
